import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useSelector } from "react-redux";
import axios from "axios";

export function CallModal({
    show,
    onClose,
    baseUrl,
    currentUser,
    webSocketConn,
    callerName,
    callId,
    type,
    stopRingtone,
    clearCallTimeout,
}) {


    const [error, setError] = useState("");
    const navigate = useNavigate();
    const client = useSelector((state) => state.client.client);
    const client_uid = client?.uid || "clnt_QI9Jd1m0";

    // const [responseAgent, setResponseAgent] = useState(false);

    //reset states on close
    useEffect(() => {
        if (!show) {
            setError("");
        }
    })

    // ESC key to close
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
        };
        if (show) window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [show, onClose]);

    const handleRejectIncomingCall = (call_id) => {
        clearCallTimeout();
        stopRingtone();
        if (type === "audio") {
            axios.get(baseUrl + '/actionAudioCall', { params: { call_id: call_id, action: "reject" }, }).then(res => {
                console.log(res.data);
                if (res.data.status === "OK") {
                    var data = {
                        call_history_id: call_id,
                        about: "WebCall_rejected_by_agent",
                        channel: "common_channel",
                        type: "audio_call",
                    }
                    webSocketConn.send(JSON.stringify(data));
                    onClose();
                }
            })
        } else {
            axios.get(baseUrl + '/actionVideoCall', { params: { call_id: call_id, action: "reject" }, }).then(res => {
                console.log(res.data);
                if (res.data.status === "OK") {
                    var data = {
                        call_history_id: call_id,
                        about: "rejected_call",
                        channel: "common_channel",
                        type: "video_call",
                    }
                    webSocketConn.send(JSON.stringify(data));
                    onClose();
                }
            })
        }
    }
    const handleAcceptIncomingCall = (call_id) => {
        clearCallTimeout();
        stopRingtone();
        if (type === "audio") {
            axios.get(baseUrl + '/actionAudioCall', { params: { call_id: call_id, action: "accept" }, }).then(res => {
                console.log(res.data);
                if (res.data.status === "OK") {
                    var data = {
                        call_history_id: call_id,
                        about: "WebCall_accepted_call",
                        channel: "common_channel",
                        type: "audio_call",
                    }
                    webSocketConn.send(JSON.stringify(data));
                    window.open("one-to-one-audio-call/" + call_id, "_blank");
                    onClose();
                }
            })
        } else {
            axios.get(baseUrl + '/actionVideoCall', { params: { call_id: call_id, action: "accept" }, }).then(res => {
                console.log(res.data);
                if (res.data.status === "OK") {
                    var data = {
                        call_history_id: call_id,
                        about: "accepted_call",
                        channel: "common_channel",
                        type: "video_call",
                    }
                    webSocketConn.send(JSON.stringify(data));
                    window.open("one-to-one-video-call/" + call_id, "_blank");
                    onClose();
                }
            })
        }
    }

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <motion.div
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.9, opacity: 0 }}
                        transition={{ duration: 0.25 }}
                        onClick={(e) => e.stopPropagation()}
                        role="dialog"
                        aria-modal="true"
                        className="relative bg-black rounded-2xl shadow-xl w-full max-w-sm p-6"
                    >
                        <button
                            onClick={onClose}
                            className="absolute top-3 right-3 text-white hover:text-white-800"
                        >
                            ✕
                        </button>

                        (
                        <>
                            <h2 className="text-xl font-bold mb-4 text-white text-center">Incoming {type}</h2>
                            <form className="space-y-6">
                                {/* Minutes Selection */}
                                <div className="text-center">
                                    <p className="text-sm text-white" id="call-type-with-caller">call from <strong>{callerName}</strong></p>
                                </div>

                                {/* Payment Method Selection */}
                                <div>
                                    <div className="flex flex-wrap justify-between">

                                        <button
                                            key={`Avvis`}
                                            type="button"
                                            onClick={() => handleRejectIncomingCall(callId)}
                                            className={`px-3 py-1 rounded-full text-sm font-semibold transition border capitalize text-white bg-red-700 hover:bg-red-800`}
                                        >
                                            Avvis
                                        </button>
                                        <button
                                            key={`Akseptere`}
                                            type="button"
                                            onClick={() => handleAcceptIncomingCall(callId)}
                                            className={`px-3 py-1 rounded-full text-sm font-semibold transition border capitalize text-white bg-green-700 hover:bg-green-800`}
                                        >
                                            Akseptere
                                        </button>
                                    </div>
                                </div>

                                {error && <p className="text-sm text-red-600">{error}</p>}
                            </form>
                        </>
                        )
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
